import React from "react";
import { useTranslation } from "next-i18next";

import WebV2FaqSection from "../../../../homepage-v2/web-v2-faq-section/WebV2FaqSection";
import Styles from "./MarketplaceV3FaqSection.module.scss";

type MarketplaceV3FaqSectionProps = {
    faqItems: Array<{ question: string; answer: string }>;
};

const MarketplaceV3FaqSection = ({ faqItems }: MarketplaceV3FaqSectionProps) => {
    const { t } = useTranslation("marketplaceV3");

    return (
        <WebV2FaqSection
            title={t("faq.title")}
            items={faqItems}
            align="left"
            containerClassName={Styles.container}
            titleClassName={Styles.title}
        />
    );
};

export default MarketplaceV3FaqSection;
